module.exports = __webpack_public_path__ + "static/media/9D.a578d7b2.svg";